import { type CanvasTokenNode } from './store/slices/createCanvasTokenNodeSlice';

export const EMPTY_NODES: Record<string, CanvasTokenNode> = {};
